import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FormType } from './types';

export const createForm = () => {
  return new FormGroup<FormType>({
    uuid: new FormControl(null),
    template: new FormControl(undefined, { nonNullable: true, validators: [Validators.required] }),
    name: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    description: new FormControl(null),
    formats: new FormControl([], { nonNullable: true }),
    isEnabled: new FormControl(false, { nonNullable: true }),
    categories: new FormControl([], { nonNullable: true }),
  });
};
